/** Date and period labels shared by the document list, the card and the journal. */

export function formatDate(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (match === null) {
    return iso;
  }
  return `${match[3]}.${match[2]}.${match[1]}`;
}

/** `formatPeriod(2026, 11, months)` -> `Noyabr 2026`. */
export function formatPeriod(year: number, month: number, monthNames: readonly string[]): string {
  const name = monthNames[month - 1] ?? `${month}`;
  return `${name} ${year}`;
}
